const queryString = require('query-string')

export default function addItemNumberToQuery(search, itemNumber) {
  const qs = queryString.parse(search)
  const newQS = {
    ...qs,
    item: itemNumber,
  }
  return queryString.stringify(newQS)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/addItemNumberToQuery.js